import ServiceBase from './ServiceBase';

export default class ImagesService extends ServiceBase {

    deleteProjectGalleryItem(galleryItemID, projectID) {
        const params = {
            galleryItemID,
            projectID,
        };

        return this.request('post', 'images/deleteProjectGalleryItem', params);
    }

    addProjectGalleryVideo(temporaryImageUrl, projectID, projectPhase, videoUrl, languageIsoCode, replaceGalleryItemID = null) {
        const galleryItem = {
            temporaryImageUrl,
            projectID,
            projectPhase,
            videoUrl,
            languageIsoCode,
            replaceGalleryItemID,
        };

        return this.request('post', 'images/addProjectGalleryVideo', galleryItem);
    }

    addProjectGalleryImage(temporaryImageUrl, projectID, projectPhase, languageIsoCode, replaceGalleryItemID = null) {
        const galleryItem = {
            temporaryImageUrl,
            projectID,
            projectPhase,
            replaceGalleryItemID,
            languageIsoCode,
        };

        return this.request('post', 'images/addProjectGalleryImage', galleryItem);
    }

    deleteCreatorGalleryItem(galleryItemID, creatorID) {
        const params = {
            galleryItemID,
            creatorID,
        };

        return this.request('post', 'images/deleteCreatorGalleryItem', params);
    }

    addCreatorGalleryImage(temporaryImageUrl, creatorID, replaceGalleryItemID = null) {
        const params = {
            temporaryImageUrl,
            creatorID,
            replaceGalleryItemID,
        };

        return this.request('post', 'images/addCreatorGalleryImage', params);
    }

    addProductImage(projectID, temporaryImageUrl, productID, replaceProductImageID = null) {
        const params = {
            projectID,
            temporaryImageUrl,
            productID,
            replaceProductImageID,
        };

        return this.request('post', 'images/addProductImage', params);
    }

    deleteProductImage(projectID, productImageID) {
        const params = {
            projectID,
            productImageID,
        };

        return this.request('post', 'images/deleteProductImage', params);
    }

    reorderProductImage(projectID, productImageID, sortOrder) {
        const params = {
            projectID,
            productImageID,
            sortOrder,
        };

        return this.request('post', 'images/reorderProductImage', params);
    }

    getProductImages(productID, projectID) {
        return this.request('get', 'images/getProductImages', { productID, projectID });
    }

    static get GalleryItemTypeValues() {
        return {
            Image: 0,
            Video: 1,
        };
    }

    uploadAvatar(formData) {
        return this.request('post', '/images/uploadAvatarImage', formData);
    }
}
